import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './components/app.component';
import { MsalGuard } from '@azure/msal-angular';
import { FormsModule } from '@angular/forms';
import {CustomMaterialModule} from './shared/custom-material.module';
import { NonTerritoryDashboardComponent } from './NewUI-modules/components/non-territory-dashboard/non-territory-dashboard.component';
import { ChatbotComponent } from './NewUI-modules/components/chat-bot/chat-bot.component';
import { betaAccessGuard } from 'src/beta-access.guard';
import { authInitGuard } from 'src/auth-init.guard';
import { TerritoryViewComponent } from './NewUI-modules/components/territory-view/territory-view.component';
import { TerritoryDashboardComponent } from './NewUI-modules/components/territory-dashboard/territory-dashboard.component';
const routes: Routes = [
  { path: '', component: AppComponent, pathMatch: 'full', canActivate: [MsalGuard] },
  { path: 'shipto/:shipto', component: AppComponent },
  { path: 'nonTerritoryDashboard', component: NonTerritoryDashboardComponent, canActivate: [authInitGuard, betaAccessGuard] },
  { path: 'territoryView', component: TerritoryViewComponent, canActivate: [authInitGuard, betaAccessGuard] },
  { path: 'territorydashboard', component: TerritoryDashboardComponent, canActivate: [authInitGuard, betaAccessGuard] },
  { path: 'chatbot', component: ChatbotComponent },
  { path: 'orderStatus', loadChildren: () => import('./feature-modules/orders/orders.module').then(m => m.OrdersModule), canActivate: [MsalGuard,authInitGuard] },
  { path: '**', component: AppComponent, canActivate: [MsalGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true, scrollPositionRestoration: 'enabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
